/**
 * Who runs FilmSloth, in one place.
 *
 * The same name, address and mail box have to appear in the legal notice, on
 * the contact page and as the controller in the privacy policy. Three copies
 * would mean three chances to move house and forget one of them — and stale
 * contact details are exactly what gets an AdSense account deactivated and a
 * German imprint fined. So they are written once here and read from there.
 */
export const SITE_OWNER = {
  name: 'Johannes Mahl',
  street: 'Schloßstraße 9',
  city: '60486 Frankfurt am Main',
  country: 'Deutschland',
  email: 'kontakt.filmsloth@gmail.com',
} as const;
